<template>
  <div style="clear: both; width: 100%">

    <div x-layout v-if="loading" align-center justify-center row
      style="position: absolute; width: 100%; margin-top: 200px;">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      />
    </div>
    <vue-friendly-iframe
      v-if="src && src.length > 1"
      v-bind="{
        ...$attrs,
        src
      }"

      v-on="{
        ...$listeners
      }"
      :style="{height: this.height + 'px'}"
      @load="loadOk(); T.log('[s-report] load')"
      @document-load="T.log('[s-report] documentLoad')"
    />
    <div v-else>
      <!-- 레포트 출력 대기중 입니다. -->
    </div>
    <!-- <vue-friendly-iframe
      src="https://via.imdsvr.com/ClipReport4/event_print.jsp?event_nm=1&event_seq=5282"
      @load="T.log('I-FRAME load')"
      @document-load="T.log('I-FRAME documentLoad')"
    /> -->

  </div>
</template>

<style>

.vue-friendly-iframe { width: 100% }
.vue-friendly-iframe iframe {
  width : 100%;
  height : 100%;
}
</style>

<script>
export default {
  inheritAttrs: false,
  props : {
    src: { type: String, required: true, },
    height: { type: [String, Number], default: 800, },
  },
  data() {
    return {
      loading: false,
      timerInst: null,
    }
  },
  watch: {
    src(n) {
      clearTimeout(this.timerInst)
      // this.loading = (n && n.length > 1)
    }
  },
  methods: {
    loadOk() {
      // this.timerInst = setTimeout(()=>this.loading=false,3000);
    }
  },
}
</script>
